document.addEventListener('alpine:init', () => {
    Alpine.data('upgradeProduct', (line_item, current_item, selling_plan_id) => ({
        adding: false,
        product: JSON.parse(line_item),
        initialized: false,
        init() {
            if (!this.initialized) {
                this.$nextTick(() => {
                    this.addEventListeners();
                    this.initialized = true;
                });
            }
        },
      
        async addProduct() {
            let currentItemKey = { current_item_key: current_item };
            let currentItem = { ...currentItemKey, ...this.product };
            this.adding = true;
            this.replaceCartItem(selling_plan_id, currentItem.id, currentItem.current_item_key)

        },
        async replaceCartItem(sellingPlan, variantId, productKey) {
            await this.changeItemQuantity(productKey, 0, true)
            await this.addCartItem(sellingPlan, variantId, productKey)
        },
        async addCartItem(sellingPlan, variantId, productKey) {

            await fetch('/cart/add.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    id: variantId,
                    quantity: 1,
                    selling_plan: sellingPlan,
                    properties: sellingPlan ? { subscribed: 'true' } : { onetime: 'true'}
                }),
            })
                .then(response => response.json())
                .then(json => {
                    this.currentItemKey = productKey
                    this.$dispatch('product:added', this.cart)
                })
                .catch(error => {
                    console.error(error);
                });
        }
      
    }));
});